/**
 * Which identity provider the portal authenticates against.
 *
 * The portal is migrating from Auth0 to the BeamXR OpenIddict identity service. Both are
 * supported at once so the switch is a single environment variable and can be reverted without
 * a code change. Once the migration is complete the Auth0 branch, and this flag, can go.
 */
export type AuthProviderKind = "auth0" | "openiddict";

export const authProvider: AuthProviderKind =
  (process.env.REACT_APP_AUTH_PROVIDER as AuthProviderKind) === "openiddict"
    ? "openiddict"
    : "auth0";

export const isOpenIddict = authProvider === "openiddict";

/** Auth0 settings. Used only while {@link authProvider} is "auth0". */
export const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN as string,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID as string,
  scope: process.env.REACT_APP_AUTH0_SCOPE,
  audience: process.env.REACT_APP_AUTH0_AUDIENCE,
};

/** OpenIddict settings. Used only while {@link authProvider} is "openiddict". */
export const openIddictConfig = {
  authority: process.env.REACT_APP_OIDC_AUTHORITY as string,
  clientId: process.env.REACT_APP_OIDC_CLIENT_ID as string,
  scope:
    process.env.REACT_APP_OIDC_SCOPE ??
    "openid profile email offline_access beamxr.api",
  /**
   * Must exactly match a redirect URI registered for this client in
   * OpenIddictClientSeedHostedService, including the path.
   */
  redirectUri: `${window.location.origin}/callback`,
  postLogoutRedirectUri: window.location.origin,
};
